import { useQuery } from '@tanstack/react-query'
import { Descriptions, Table, Tag, Tooltip, Typography } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import { workspaceQueries } from '../../../../Actions'
import { ACTIVITY_STATE_COLOR, ACTIVITY_STATE_LABEL } from '../../../../types/credit'

type Props = {
  workspaceId: number
}

export default function WorkspaceDetails({ workspaceId }: Props) {
  const { data: details } = useQuery({
    ...workspaceQueries.detail(Number(workspaceId)),
  })
  // 구독·시각에서 파생 판정한다. SubscriptionStatus 와 다른 축이다
  const { data: activity } = useQuery({
    ...workspaceQueries.detail(Number(workspaceId))._ctx.activityState,
  })

  return (
    <>
      {/* <Typography.Title level={3}>Details</Typography.Title> */}
      {details?.members && (
        <div style={{ marginBottom: 20 }}>
          <Typography.Title level={4}>Members</Typography.Title>
          <Table
            dataSource={details.members}
            pagination={false}
            rowKey={(record: any) => record.id}
            columns={[
              {
                title: 'userId',
                dataIndex: 'userId',
                key: 'id',
              },
              {
                title: 'email',
                dataIndex: 'email',
                key: 'email',
                render: (t, r) => <Link to={`/user/${r.userId}`}>{r.email}</Link>,
              },
              {
                title: 'role',
                dataIndex: 'role',
                key: 'role',
              },
            ]}
          />
        </div>
      )}

      {/* Subscription */}
      {details?.subscription && (
        <div style={{ marginBottom: 20 }}>
          {/* <Typography.Title level={4}>
                Subscription
                <Button style={{ marginLeft: 20 }} onClick={() => navigate(`${details?.id}`)}>history</Button>
              </Typography.Title> */}
          <Descriptions column={2} bordered>
            <Descriptions.Item label="Plan">{details.subscription?.plan?.name}</Descriptions.Item>
            <Descriptions.Item label="Status">{details.subscription?.status}</Descriptions.Item>
            <Descriptions.Item label="Started At">{details.subscription?.startedAt}</Descriptions.Item>
            <Descriptions.Item label="Ended At">{details.subscription?.endAt}</Descriptions.Item>
            {/* <Descriptions.Item label="Sub At">
              {moment(details.subscription?.subscribedAt).format('YYYY-MM-DD HH:mm')}
            </Descriptions.Item>
            <Descriptions.Item label="Unsub At">
              {moment(details.subscription?.unsubscribedAt).format('YYYY-MM-DD HH:mm')}
            </Descriptions.Item> */}
            <Descriptions.Item label="Interval">{details.subscription?.intervalMonth}</Descriptions.Item>
            <Descriptions.Item label="Valid To">{details.subscription?.validTo}</Descriptions.Item>
          </Descriptions>
        </div>
      )}

      {/* 비활성 파생 상태. 위 Status(구독 상태)와 다른 축이다 — 상태1 의 구독 status 는 PAUSE 이고,
          SubscriptionStatus.INACTIVE 는 "다른 구독으로 대체된 과거 구독 행" 을 뜻한다 */}
      <div style={{ marginBottom: 20 }}>
        <Descriptions
          column={3}
          bordered
          title={
            <Tooltip title="구독 상태(위 Status)와 다른 축입니다. 서버가 판정한 값을 그대로 표시합니다 — 월 경계는 말일 보정·반열림이라 화면에서 재계산하지 않습니다.">
              <Typography.Text>활성 상태 (파생 판정)</Typography.Text>
            </Tooltip>
          }
        >
          <Descriptions.Item label="활성 상태">
            {activity ? (
              <Tag color={ACTIVITY_STATE_COLOR[activity.state]}>{ACTIVITY_STATE_LABEL[activity.state]}</Tag>
            ) : (
              '-'
            )}
          </Descriptions.Item>
          <Descriptions.Item label="기준 시각 (pause 시작일)">{activity?.inactiveSince ?? '-'}</Descriptions.Item>
          <Descriptions.Item label="다음 단계 전환일">
            {activity?.nextStateAt ?? (activity?.state === 'INACTIVE_3' ? '없음 (상한 없음)' : '-')}
          </Descriptions.Item>
          <Descriptions.Item label="판정 기준일" span={3}>
            {activity?.evaluatedAt ?? '-'}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </>
  )
}
